import { Feather } from '@expo/vector-icons';
import { useNavigation } from '@react-navigation/native';
import { Text } from '_/space-management/components';
import { colors } from '_/space-management/constants/theme';
import { useDateContext } from '_/space-management/hooks/DateContext';
import { useSpaceContext } from '_/space-management/hooks/SpaceContext';
import { AppRoute } from '_/space-management/navigation/types';
import {
  spaceTypeName,
  spaceTypeIcon,
} from '_/space-management/services/models/enums/space-type.enum';
import { SpacesModel } from '_/space-management/services/models/spaces.model';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TouchableOpacity, View } from 'react-native';

import styles from './styles';
import { fontSizes } from '_/config/theme';

export interface CardProps {
  locationName?: string;
  space: SpacesProps;
}

export interface SpacesProps extends SpacesModel {
  availableSlotsCount: string;
}

export default function Card({ locationName, space }: CardProps) {
  const navigation = useNavigation<any>();
  const { t } = useTranslation();
  const { setSpaceId, setSpaceType, setLayoutMode, setCurrentSpace } = useSpaceContext();

  const { reset } = useDateContext();
  const spaceType = space.type;

  return (
    <TouchableOpacity
      style={styles(spaceType).card}
      onPress={() => {
        reset();
        setSpaceType(space.type);
        setSpaceId(space.id);
        setCurrentSpace(space);
        if (space?.isMapVisible === true) {
          setLayoutMode('map');
        }
        navigation.navigate(AppRoute.DATE_PICKER, {
          availableSlotsCount: space.availableSlotsCount,
          space,
          locationName,
        });
      }}
    >
      <View style={styles().artGroup}>
        <View style={styles(spaceType).artOne} />
        <View style={styles(spaceType).artTwo} />
        <View style={styles(spaceType).artThree} />
      </View>
      <View style={styles().titleContainer}>
        <Feather name={spaceTypeIcon[spaceType] as any} size={24} color={colors.white} />
        <Text style={styles().title} fontSize={18} fontType="bold" color={colors.white}>
          {space.name}
        </Text>
      </View>
      <Text fontSize={fontSizes.md2} color={colors.white}>
        {t(`spaceManage.spaceTypes.${spaceTypeName[spaceType]}`)}
      </Text>
      {/* <Text fontSize={fontSizes.md} color={colors.white}>
        {space.availableSlotsCount}
      </Text> */}
    </TouchableOpacity>
  );
}
